import { Box, Typography } from '@mui/material';

type MobileGridResultsCountProps = {
  count: number;
};

export const MobileGridResultsCount = ({ count }: MobileGridResultsCountProps) => {
  if (count <= 0) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: { xs: 96 },
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
        zIndex: t => t.zIndex.fab
      }}
    >
      <Box
        sx={{
          pointerEvents: 'auto',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 20,
          px: 1,
          py: 0.5,
          borderRadius: '50px',
          bgcolor: 'background.paper',
          color: 'text.primary',
          boxShadow: 1,
          border: 1,
          borderColor: 'divider',
          maxWidth: 'min(100vw - 24px, 400px)'
        }}
      >
        <Typography
          component="p"
          variant="caption"
          fontWeight={600}
          sx={{ m: 0, textAlign: 'center', fontSize: '0.7rem', lineHeight: 1.2 }}
        >
          {count.toLocaleString('he-IL')} תוצאות
        </Typography>
      </Box>
    </Box>
  );
};
